// GDPR cookie consent utility. Stores the user's choice in localStorage and
// dispatches a `cookieConsent:change` window event whenever it changes, so
// third-party trackers (PostHog etc.) can react without a page reload.

const STORAGE_KEY = 'abneylow.cookieConsent.v1';

export const CATEGORIES = ['necessary', 'analytical', 'functionality', 'targeting'];

export function getConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_e) {
    return null;
  }
}

export function hasConsented() {
  return getConsent() !== null;
}

export function hasConsent(category) {
  const c = getConsent();
  if (!c) return false;
  if (category === 'necessary') return true;
  return Boolean(c[category]);
}

export function setConsent(prefs) {
  const payload = {
    necessary: true,
    analytical: Boolean(prefs.analytical),
    functionality: Boolean(prefs.functionality),
    targeting: Boolean(prefs.targeting),
    ts: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  window.dispatchEvent(new CustomEvent('cookieConsent:change', { detail: payload }));
  // expose a global helper so the inline PostHog boot script in index.html can
  // check consent without importing this module.
  window.__abneyLowConsent = payload;
  return payload;
}

export function acceptAll() {
  return setConsent({ analytical: true, functionality: true, targeting: true });
}

export function rejectAll() {
  return setConsent({ analytical: false, functionality: false, targeting: false });
}

export function openPreferences() {
  window.dispatchEvent(new Event('cookieConsent:openPreferences'));
}
